import React, { useEffect, useState } from 'react';
import gsap from 'gsap';
import Header from '../Header';
import axios from 'axios';
import { toast } from 'react-toastify';


const animateFunc = element => {
  const tl = gsap.timeline();
  tl.fromTo(
    element,
    { scale: 0.3, opacity: 0 },
    {
      scale: 1,
      opacity: 1,
      zIndex: 100,
      duration: 0.2,
      yoyo: true,
      repeat: 1,
      ease: 'power1.in',
      immediateRender: false,
      textShadow: '0px 0px 1.5vw rgb(255, 253, 229)',
    }
  ).fromTo(
    element,
    { yPercent: 400 },
    { yPercent: -400, duration: 0.4, ease: 'none', immediateRender: false },
    0
  );
  return tl;
};

const buildSeamlessLoop = (items, spacing, animateFunc, onCenterChange) => {
    let rawSequence = gsap.timeline({ paused: true }),
    seamlessLoop = gsap.timeline({
        paused: true,
        repeat: 0,
    }),
    cycleDuration = spacing * (items.length + 5),
    dur;

  items.concat(items).concat(items).forEach((item, i) => {
    let anim = animateFunc(items[i % items.length]);
    rawSequence.add(anim, i * spacing);
    dur || (dur = anim.duration());
  });

  seamlessLoop.fromTo(
    rawSequence,
    { time: cycleDuration + dur / 2 },
    {
      time: `+=${cycleDuration}`,
      duration: 15,
      ease: 'power4.out',
    }
  );
  return seamlessLoop;
};

const ElectAnimationModal = ({ isOpen, onClose, usersData, onAnimationComplete, isSoundOn, volume, setVolume }) => {
    const modalStyle = {
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out 0.2s',
        position: 'fixed',
        top: '0%',
        left: '0%',
        zIndex: 900,
    };

    const [usersRandomData, setUsersRandomData] = useState(usersData);

    const audioFiles = ['sound/Song-1.mp3', 'sound/Song-2.mp3'];
    const randomIndex = Math.floor(Math.random() * audioFiles.length);
    const [audio] = useState(new Audio(audioFiles[randomIndex]));
    const [audio_scroll_show] = useState(new Audio('sound/button_sound/Main_ANIM2.ogg'));
    
    
    useEffect(() => {
      audio.play();
      audio_scroll_show.play();
      // Play or pause audio based on isSoundOn
      if (isSoundOn) {
        audio.volume = volume / 100;
        audio_scroll_show.volume = volume / 100;
      } else {
        // audio.pause();
        // audio_scroll_show.pause();
        audio.volume = 0;
        audio_scroll_show.volume = 0;
      }
    }, [isSoundOn, audio, audio_scroll_show, volume]);

    const shuffleArray = (array) => {
        const shuffledArray = array.slice(); // Copy the original array
        for (let i = shuffledArray.length - 1; i > 0; i--) {
          const randomIndex = Math.floor(Math.random() * (i + 1));
          [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
        }
        return shuffledArray;
    };

    const findLargestStoppedList = (listElements) => {
        let largestStoppedList = null;
        let largestScale = 0;

        listElements.forEach((listElement) => {
            const scale = gsap.getProperty(listElement, 'scale');
            const timeline = gsap.timeline(listElement);
            
            // Check if the timeline is paused using totalProgress
            const isStopped = timeline.totalProgress() === 0;
            
            if (isStopped && scale > largestScale) {
                largestScale = scale;
                largestStoppedList = listElement;
            }
        });

        return largestStoppedList;
    };

    useEffect(() => {
        if(usersData.length < 50) {
            let repeatedArray = [];
            while (repeatedArray.length < 50) {
            repeatedArray = [...repeatedArray, ...usersData];
            }

            // Trim the array to make its length exactly 50
            const finalArray = repeatedArray.slice(0, 50);

            const shuffledUsersData = shuffleArray(finalArray);
            setUsersRandomData(shuffledUsersData);
        } else {            
            const shuffledUsersData = shuffleArray(usersData);
            setUsersRandomData(shuffledUsersData);
        }
    }, [usersData]);

    

    useEffect(() => {
        const ulElement = document.querySelector('.cards');
        // const topFrameElement = document.querySelector('.top-frame-selection');
        // const bottomFrameElement = document.querySelector('.bottom-frame-selection');
        const topTitleElement = document.querySelector('.top-animation-title');
        const bottomTitleElement = document.querySelector('.bottom-animation-title');

        const titleAnimationTimeline = gsap.timeline();
        titleAnimationTimeline.fromTo(topTitleElement, { scale: 2, opacity: 0 }, { scale: 1, opacity: 1, ease: 'power2.out' });
        titleAnimationTimeline.fromTo(bottomTitleElement, { scale: 3, opacity: 0 }, { scale: 1, opacity: 1, ease: 'power2.out' }, "<0.2");
        titleAnimationTimeline.play();

        // gsap.fromTo(topTitleElement, { scale: 3 }, { scale: 1, ease: 'power2.out' });
        // gsap.fromTo(bottomTitleElement, { scale: 3 }, { scale: 1, ease: 'power2.out' });
        gsap.fromTo(ulElement, { y: '-100vh' }, { y: '0%', duration: 1, ease: 'power2.Out', onComplete: startSeamlessLoop });
    
        function startSeamlessLoop() {
            gsap.set('.cards li', { yPercent: 400, opacity: 0, scale: 0 });
        
            const spacing = 0.05;
            let cards = gsap.utils.toArray('.cards li');
        
            const onCenterChange = centerElement => {
              // Do something with the centerElement when it changes
            };
        
            const seamlessLoop = buildSeamlessLoop(cards, spacing, animateFunc, onCenterChange);
        
            const giggleEffect = gsap.timeline();
            seamlessLoop.eventCallback('onComplete', () => {
                const specificDataToSend = usersRandomData[10];
                onAnimationComplete(specificDataToSend);

                const largestStoppedList = findLargestStoppedList(cards);

                giggleEffect.to(
                    largestStoppedList,
                    { rotation: '+=10', yoyo: true, repeat: 17, duration: 0.1, ease: 'power3.inOut' },
                    0
                );
                

                const expandAnimation = gsap.timeline({
                    onComplete: () => {
                          gsap.to(audio, { volume: 0, duration: 1, onComplete: () => {
                            audio.pause();
                          }});
                        onClose();
                    }
                });

                expandAnimation.fromTo(
                    '.white-back-animation',
                    { opacity: 0 },
                    { opacity: 1, duration: 2.5, ease: 'power2.inOut' },
                    0
                );

                expandAnimation.fromTo(
                    largestStoppedList,
                    { scale: 1},
                    { scale: 9, top: '5%',duration: 2.5, ease: 'power2.inOut' },
                    0
                );

                expandAnimation.play();
            });

            const giggleDuration = 2;
            gsap.delayedCall(giggleDuration, () => {
                giggleEffect.play();
            });
    
            seamlessLoop.play();
        
            return () => seamlessLoop.pause();
        }
      }, [usersRandomData]);

    return (
      <>
        <div className="animation-modal" style={modalStyle}>
            <Header />
            <div className="top-frame-selection"></div>
            <div className="bottom-frame-selection"></div>
            <div className="top-animation-title"></div>
            <div className="bottom-animation-title"></div>
            <div className="animation-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="gallery">
                <ul className="cards">
                    {usersRandomData.map((value, key) => {
                        return <li key={key}>{value.user_name}</li>
                    })}
                </ul>
            </div>
            </div>
        </div>
        <div className="animation-board"></div>
        <div className="white-back-animation"></div>
      </>
    );
};

export default ElectAnimationModal;